import { ConfigStepFooter as CsvConfigStepFooter } from '../../../../../../../../components/csv-import/ui/components/steps/create-config-step/create-config-step';
import { useImportContext } from '../../../../../../../../components/csv-import/ui/components/import-context';

export const ConfigStepFooter = () => {
  const { form } = useImportContext();
  return <CsvConfigStepFooter isInitImportBtnDisabled={!form?.inventoryWarehouseId} />;
};
